import { useSyncExternalStore } from 'react';

// Add new themes here. The first is the default. Pick another with ?theme=<id> on a full page load;
// it holds while you navigate inside the app and resets to the default on reload.
export const THEMES = [
  { id: 'paper', label: 'Paper' },
  { id: 'legacy', label: 'Legacy' },
];
const DEFAULT = THEMES[0].id;
const valid = (t) => THEMES.some((x) => x.id === t);

let current = DEFAULT;
if (typeof window !== 'undefined') {
  const fromUrl = new URLSearchParams(window.location.search).get('theme');
  if (valid(fromUrl)) current = fromUrl;
  try { localStorage.removeItem('blog-theme'); } catch (e) { /* older versions saved the choice here */ }
}
if (typeof document !== 'undefined') document.documentElement.dataset.theme = current;

export const useTheme = () =>
  useSyncExternalStore(() => () => {}, () => current, () => DEFAULT);

// For non-React code (e.g. chart option objects) that needs the theme once at load.
export const currentTheme = () => current;
